module.exports = __webpack_public_path__ + "static/media/searchIcon.4d186420.svg";